import { Navigate, RouteObject } from 'react-router-dom';
import { Login } from '../pages/Auth/Login';
import { MainLayout } from '../components/Layout';
import { PrivateRoutes } from './PrivateRoutes';
import { ForgotPassword } from '../pages/Auth/ForgotPassword';
import { ResetPassword } from '../pages/Auth/ResetPassword';
import { LimitExceeded } from '../pages/Auth/LimitExceeded';
import { ExpiredLink } from '../pages/ExpiredLink';
import { NotFound } from '../pages/NotFound';
import { AdminPanel } from '../pages/AdminPanel';
import { Dashboard } from '../pages/Dashboard';
import { PastTenders } from '../pages/PastTenders';
import { SignUp } from '../pages/SignUp';
import { ManageProfile } from '../pages/ManageProfile';
import { EmailVarification } from '../pages/EmailVarification';
import { TenderViewPage } from '../pages/TenderViewPage/TenderViewPage';
import { SupplierVarification } from '../pages/SupplierVarification/SupplierVarification';
import { SuppSelfRegistration } from '../pages/SuppSelfRegistration';
import { EmailConfirmation } from '../pages/EmailConfirmation';
import { SupplierFeedback } from '../pages/SupplierFeedback/SupplierFeedback';
import { ManageUsers } from '../pages/AdminPanel/ManageUsers';
import { ManageSchools } from '../pages/AdminPanel/ManageSchools';
import { ManageSuppliers } from '../pages/AdminPanel/ManageSuppliers';
import { ManageExpenseAreas } from '../pages/AdminPanel/ManageExpenseAreas';
import { SupplierProfileQuestionnaireBuilder } from '../pages/AdminPanel/ManageExpenseAreas/components/documents/SPQ/SupplierProfileQuestionnaireBuilder';
import { KikOffQuestionaryBuilder } from '../pages/AdminPanel/ManageExpenseAreas/components/documents/Kik-off/KikOffQuestionaryBuilder';
import { ScoreCardBuilder } from '../pages/AdminPanel/ManageExpenseAreas/components/documents/Scorecard/ScoreCardBuilder';
import { AdminPanelIndexRedirect } from './AdminPanelIndexRedirect';
import { SupplierCompanyPitches } from '../pages/SupplierCompanyPitches';
import { ScoreCardPage } from '../pages/ScoreCard/index.tsx';
import { DownloadDocument } from '../pages/DownloadDocument';

const authRoutes: RouteObject[] = [
    {
        path: '/login',
        element: <Login />
    },
    {
        path: '/register/supplier',
        element: <SignUp />
    },
    {
        path: '/redirects/supplier-confirm-company-number',
        element: <SignUp />
    },
    {
        path: '/supplier-company/tender-registration',
        element: <SuppSelfRegistration />
    },
    {
        path: '/supplier-company/email-confirmed',
        element: <EmailConfirmation />
    },
    {
        path: '/supplier-company/verification',
        element: <SupplierVarification />
    },
    {
        path: '/supplier-company/sign-tpa',
        element: <SupplierVarification />
    },
    {
        path: '/supplier-company/unverification',
        element: <SupplierVarification />
    },
    {
        path: '/supplier-company/unverified',
        element: <SupplierVarification />
    },
    {
        path: '/forgot-password',
        element: <ForgotPassword />
    },
    { path: '/forgot-password/limit-exceeded', element: <LimitExceeded /> },
    {
        path: '/reset-password',
        element: <ResetPassword />
    },
    {
        path: '/sign-up*',
        element: <SignUp />
    },
    {
        path: '/email-verification*',
        element: <EmailVarification />
    },
    {
        path: '/supplier-company/feedback',
        element: <SupplierFeedback />
    },
    {
        path: '/supplier-company/tender-pitch',
        element: <SupplierCompanyPitches />
    },
    {
        path: '/download-document',
        element: <DownloadDocument />
    }
];

const privateRoutes: RouteObject[] = [
    {
        index: true,
        element: <Navigate to="/dashboard" replace />
    },
    {
        path: 'dashboard',
        element: <Dashboard />
    },

    {
        path: 'past-tenders',
        element: <PastTenders />
    },
    {
        path: 'profile',
        element: <ManageProfile />
    },
    {
        path: '/tender/:id',
        element: <TenderViewPage />
    },

    {
        path: 'admin-panel',
        element: <AdminPanel />,
        children: [
            {
                index: true,
                element: <AdminPanelIndexRedirect />
            },
            {
                path: 'users',
                element: <ManageUsers />
            },
            {
                path: 'organisations',
                element: <ManageSchools />
            },
            {
                path: 'suppliers',
                element: <ManageSuppliers />
            },
            {
                path: 'expense_areas',
                element: <ManageExpenseAreas />
            }
        ]
    }
];

const commonRoutes: RouteObject[] = [
    {
        path: '/expired',
        element: <ExpiredLink />
    },
    {
        path: '/supplier-profile-questionnaire-builder/:id',
        element: <SupplierProfileQuestionnaireBuilder />
    },
    {
        path: '/kick-off-questionnaire-builder/:id',
        element: <KikOffQuestionaryBuilder />
    },
    {
        path: '/score-card-builder/:id',
        element: <ScoreCardBuilder />
    },
    {
        path: '/supplier-company/score-card',
        element: <ScoreCardPage />
    },
    {
        path: '*',
        element: <NotFound />
    },
    {
        path: '/not-found',
        element: <NotFound />
    }
];

export const routes = [
    {
        element: <PrivateRoutes />,
        children: [
            {
                path: '/',
                element: <MainLayout />,
                children: privateRoutes
            }
        ]
    },
    ...authRoutes,
    ...commonRoutes
];
